import $api from '../../utils/api.js'


const state = () => ({
    agents: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    events_agent: {
        events:[],
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Agent'
    },
    formdata:{
        id:'',
        name:'',
        email:'',
        is_active:'true',
        password:'',
        confirmation:'',
        challenge:[]
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.agents = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            email:payload.email,
            is_active:payload.is_active,
            password:'',
            confirmation:'',
            challenge:payload.challenge
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            email:'',
            is_active:'true',
            password:'',
            confirmation:'',
        },
        state.errors = []
    },
    CLEAR_AGENTS(state){
        state.agents = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },

     // EVENT Agent

    ASSIGN_DATA_AGENTS(state, payload) {
        state.formdata = payload
    },
    ASSIGN_DATA_EVENTS_AGENTS(state, payload) {
        state.events_agent = payload
    },
    CLEAR_DATA_EVENTS_AGENTS(state) {
        state.events_agent = {
            events:[],
        }
    }
}

const actions = {
    getAgents({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`agents?page=${state.agents.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createAgents({ commit, state }) {
        return new Promise((resolve,reject) => {
            $api.post(`agents`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateAgents({ state, commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`agents/${payload}`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteAgents({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`agents/${payload}`)
            .then(() => {
                dispatch('getAgents').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    changeStatusAgents({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`status/agents`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateSlotsAgents({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`slots/agents/${payload.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },

    // AGENT FOR DISTRIBUTOR

    getAgentsDistributor({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`agents/distributor?page=${state.agents.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createAgentsDistributor({ commit, state }) {
        return new Promise((resolve) => {
            $api.post(`agents/distributor`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    updateAgentsDistributor({ state, commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`agents/distributor/${payload}`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteAgentsDistributor({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`agents/distributor/${payload}`)
            .then(() => {
                dispatch('getAgentsDistributor').then(() => resolve())
            })
        })
    },
    changeStatusAgentsDistributor({ commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`status/agents/distributor`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    updateSlotsAgentsDistributor({ commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`slots/agents/distributor/${payload.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}